(function(root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory(root || globalThis);
    return;
  }

  root.ShopSimonJustViewed = factory(root);
})(typeof window !== 'undefined' ? window : globalThis, function(root) {
  var STORAGE_KEY = 'spo-recently-viewed-products';
  var MAX_RECENTLY_VIEWED = 30;
  var EXPIRATION_MS = 24 * 60 * 60 * 1000;

  function getNow(now) {
    return typeof now === 'number' ? now : Date.now();
  }

  function normalizeProductId(productId) {
    if (productId === null || productId === undefined) {
      return '';
    }

    return String(productId).trim();
  }

  function normalizeRecentViewedRecords(records, now) {
    if (!Array.isArray(records)) {
      return [];
    }

    var cutoff = getNow(now) - EXPIRATION_MS;
    var seen = {};

    return records.reduce(function(acc, record) {
      if (!record) {
        return acc;
      }

      var productId = normalizeProductId(record.productId);
      var viewedAt = Number(record.viewedAt);

      if (!productId || !Number.isFinite(viewedAt) || viewedAt < cutoff || seen[productId]) {
        return acc;
      }

      seen[productId] = true;
      acc.push({
        productId: productId,
        viewedAt: viewedAt
      });
      return acc;
    }, []).slice(0, MAX_RECENTLY_VIEWED);
  }

  function addRecentViewedRecord(records, productId, now) {
    var normalizedId = normalizeProductId(productId);
    var viewedAt = getNow(now);

    if (!normalizedId) {
      return normalizeRecentViewedRecords(records, viewedAt);
    }

    return normalizeRecentViewedRecords([{
      productId: normalizedId,
      viewedAt: viewedAt
    }].concat(normalizeRecentViewedRecords(records, viewedAt)), viewedAt);
  }

  function getRecentViewedBadgeText(options) {
    if (options && options.isJustViewed) {
      return 'JUST VIEWED';
    }

    return options && options.fallbackBadgeText ? options.fallbackBadgeText : '';
  }

  function getStorageEntries(storage) {
    if (!storage || typeof storage.length !== 'number' || typeof storage.key !== 'function') {
      return {};
    }

    var entries = {};

    try {
      for (var index = 0; index < storage.length; index++) {
        var entryKey = storage.key(index);

        if (!entryKey) {
          continue;
        }

        entries[entryKey] = storage.getItem(entryKey);
      }
    } catch (error) {
      return entries;
    }

    return entries;
  }

  function getStoredRecentViewedRecords(storage, now) {
    if (!storage) {
      return [];
    }

    var rawStoredValue = null;
    var normalizedRecords = [];
    var viewedAt = getNow(now);

    try {
      rawStoredValue = storage.getItem(STORAGE_KEY);
      normalizedRecords = normalizeRecentViewedRecords(JSON.parse(rawStoredValue), viewedAt);
    } catch (error) {
      normalizedRecords = [];
    }

    try {
      if (rawStoredValue !== JSON.stringify(normalizedRecords)) {
        storage.setItem(STORAGE_KEY, JSON.stringify(normalizedRecords));
      }
    } catch (error) {}

    return normalizedRecords;
  }

  function saveRecentViewedRecords(storage, records, now) {
    var normalizedRecords = normalizeRecentViewedRecords(records, getNow(now));

    if (!storage) {
      return normalizedRecords;
    }

    try {
      storage.setItem(STORAGE_KEY, JSON.stringify(normalizedRecords));
    } catch (error) {}

    return normalizedRecords;
  }

  function getActiveRecentViewedIds(storage, now) {
    return getStoredRecentViewedRecords(storage, getNow(now)).map(function(record) {
      return record.productId;
    });
  }

  function rememberProductId(productId, storage, now) {
    var safeStorage = storage || (root && root.localStorage);
    var viewedAt = getNow(now);
    var updatedRecords = addRecentViewedRecord(getStoredRecentViewedRecords(safeStorage, viewedAt), productId, viewedAt);

    return saveRecentViewedRecords(safeStorage, updatedRecords, viewedAt);
  }

  function hasProductId(productId, ids) {
    var normalizedId = normalizeProductId(productId);

    return !!normalizedId && Array.isArray(ids) && ids.indexOf(normalizedId) > -1;
  }

  function getBadgeRenderState(options) {
    var isJustViewed = hasProductId(options.productId, options.activeProductIds || []);

    return {
      badgeText: getRecentViewedBadgeText({
        isJustViewed: isJustViewed,
        fallbackBadgeText: options.fallbackBadgeText
      }),
      badgeClass: isJustViewed ? 'searchJustViewedBadge' : (options.fallbackBadgeClass || '')
    };
  }

  function getDebugSnapshot(storage, now) {
    var activeRecords = getStoredRecentViewedRecords(storage, getNow(now));

    return {
      storageKey: STORAGE_KEY,
      rawStoredValue: storage ? storage.getItem(STORAGE_KEY) : null,
      activeRecords: activeRecords,
      activeProductIds: activeRecords.map(function(record) {
        return record.productId;
      }),
      storageEntries: getStorageEntries(storage)
    };
  }

  return {
    STORAGE_KEY: STORAGE_KEY,
    MAX_RECENTLY_VIEWED: MAX_RECENTLY_VIEWED,
    EXPIRATION_MS: EXPIRATION_MS,
    normalizeRecentViewedRecords: normalizeRecentViewedRecords,
    addRecentViewedRecord: addRecentViewedRecord,
    getRecentViewedBadgeText: getRecentViewedBadgeText,
    getStorageEntries: getStorageEntries,
    getStoredRecentViewedRecords: getStoredRecentViewedRecords,
    saveRecentViewedRecords: saveRecentViewedRecords,
    getActiveRecentViewedIds: getActiveRecentViewedIds,
    getBadgeRenderState: getBadgeRenderState,
    getDebugSnapshot: getDebugSnapshot,
    rememberProductId: rememberProductId,
    hasProductId: hasProductId
  };
});
